import { render } from "./GridPagination.vue?vue&type=template&id=64e7165c"
import script from "./GridPagination.vue?vue&type=script&lang=js"
export * from "./GridPagination.vue?vue&type=script&lang=js"

import "./GridPagination.vue?vue&type=style&index=0&id=64e7165c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__